import { GET_TICKET } from "../actions/types";

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_TICKET:
      // VALIDACIÓN DE SEGURIDAD:
      // Verificamos que payload exista, tenga data y que data no esté vacío.
      if (
        action.payload &&
        action.payload.data &&
        action.payload.data.length > 0
      ) {
        console.log("Ticket R:", action.payload.data[0]);
        // Retornamos el primer objeto del arreglo aplanado
        return { ...action.payload.data[0] };
      }

      // Si la respuesta no tiene el formato esperado, retornamos el estado actual
      // o podrías retornar un error genérico si prefieres.
      return state;

    default:
      return state;
  }
};
